<template>
  <div class="updatSeting">
    <el-row>
      <div class="model-header setting">
        <h2>Config Header Footer</h2>
        <el-button @click="logModel.dialogVisibleLog = true" size="small" type="info" class="btn-create">Xem log
        </el-button>
      </div>
    </el-row>
    <el-row :gutter="10">
      <div class="model-content">
        <el-row :gutter="20">
          <el-col :span="10">
            <h4>Header</h4>
            <div class="line">
              <el-input
                v-model="modelData.header_line_1"
                placeholder="HỌC VIỆN ĐÀO TẠO TRỰC TUYẾN CATIEDU"
                class="input-seach">
              </el-input>
            </div>
            <div class="line">
              <el-input
                v-model="modelData.header_line_2"
                placeholder="ĐÀO TẠO GẮN LIỀN VỚI DOANH NGHIỆP VÀ VIỆC LÀM"
                class="input-seach">
              </el-input>
            </div>
            <h4>Logo web</h4>
            <div class="line">
              <el-upload
                class="course-uploader"
                :action="upload.url_fit_fix2"
                :headers="upload.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-progress="handleAvatarProcess"
                :before-upload="beforeAvatarUpload">
                <img v-if="image_path" :src="image_path" class="courseSettig">
                <div slot="tip" class="el-upload__tip">
                  <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                  Ảnh Logo Web có kích thước tỉ lệ 268 * 198
                </div>
              </el-upload>
              <div>
                <p style="padding-left: 30px;">{{ image }}</p>
                <p style="padding-left: 30px;" v-if="image">sm_{{ image }}</p>
              </div>
            </div>
            <div class="line">
              <input type="text" placeholder="Ảnh" v-model="modelData.header_logo_web">
              <img :src="getImage(modelData.header_logo_web)" alt="" class="image-preview">
            </div>

            <!--favicon-->
            <h4>Favicon web</h4>
            <el-upload
              class="course-uploader"
              :action="upload.url_fit_fix3"
              :headers="upload.headers"
              :show-file-list="false"
              :on-success="handleFaviconSuccess"
              :on-progress="handleFaviconProcess"
              :before-upload="beforeFaviconUpload">
              <img v-if="image_path_favicon" :src="image_path_favicon" class="courseSetting">
              <div slot="tip" class="el-upload__tip">
                <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcessFavicon"></i>
                Ảnh Favicon Web có kích thước tỉ lệ 16 * 16
              </div>
            </el-upload>
            <div>
              <p style="padding-left: 30px;">{{ image_favicon }}</p>
            </div>
            <div class="line">
              <input type="text" placeholder="Ảnh" v-model="modelData.favicon">
              <img :src="modelData.favicon" alt="" class="image-preview">
            </div>
            <!--favicon end-->
            <h4>Email nhận thông báo đăng kí mới</h4>
            <el-input
              v-model="modelData.email_noti"
              placeholder=""
              class="input-seach">
            </el-input>
            <div style="padding-top: 10px;">
              <el-button
                :disable="!canSubmit"
                :loading="!canSubmit"
                type="warning"
                size="small"
                @click="testSendMail()">Gửi test
              </el-button>
            </div>
            <h4>Khai báo Google Ads đặt ở thẻ Header</h4>
            <el-input v-model="modelData.google_ads_header" :rows="11" type="textarea" class="input-seach"></el-input>
            <h4>Khai báo Google Ads đặt ở thẻ Body</h4>
            <el-input v-model="modelData.google_ads_body" :rows="11" type="textarea" class="input-seach"></el-input>
            <h4>Khai báo Google Ads đặt ở thẻ Footer (nên thêm ở đây để tăng tốc độ tải website)</h4>
            <el-input v-model="modelData.google_ads_footer" :rows="11" type="textarea" class="input-seach"></el-input>
            <h4>Khai báo Google Console</h4>
            <el-input v-model="modelData.google_console" :rows="11" type="textarea" class="input-seach"></el-input>
            <h4>Thời gian xử lý tiếp nhận đăng kí mới (phút)</h4>
            <el-input
              v-model="modelData.time_next_help_care"
              placeholder=""
              class="input-seach">
            </el-input>
          </el-col>
          <el-col :span="14">
            <h4>Địa chỉ</h4>
            <div v-for="(image_p) in modelData.footer_list_address" :key="image_p.key">
              <div class="line">
                <el-input v-model="image_p.text" class="input-seach"></el-input>
                <el-button @click.prevent="removeImage1(image_p)" size="small">Xóa</el-button>
              </div>
            </div>
            <el-button class="huhu" type="default" size="mini" @click="addImage1()">Thêm địa chỉ</el-button>
            <h4>Chăm sóc khách hàng</h4>
            <div v-for="(image_p) in modelData.footer_list_care" :key="image_p.key">
              <div class="line">
                <el-input v-model="image_p.text" class="input-seach" placeholder="Tư vấn Hà Nội"></el-input>
                <el-input v-model="image_p.number" class="input-seach" placeholder="0777 052 988"></el-input>
                <el-button @click.prevent="removeImage2(image_p)" size="small">Xóa</el-button>
              </div>
            </div>
            <el-button class="huhu" type="default" size="mini" @click="addImage2()">Thêm số</el-button>

            <h4>Liên kết - Chính sách</h4>
            <div v-for="(image_p) in modelData.footer_list_policy" :key="image_p.key">
              <div class="line">
                <el-input v-model="image_p.text" class="input-seach" placeholder="Tên liên kết"></el-input>
                <el-input v-model="image_p.link" class="input-seach" placeholder="Link liên kết"></el-input>
                <el-button @click.prevent="removeImage3(image_p)" size="small">Xóa</el-button>
              </div>
            </div>
            <el-button class="huhu" type="default" size="mini" @click="addImage3()">Thêm liên kết</el-button>

            <h4>Thông tin doanh nghiệp</h4>
            <div class="line">
              <tinymce
                id="d1"
                v-model="modelData.info_company"
                :toolbar1="tinymce.toolbar1"
                :other_options="{ height: '500px', language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
            </div>
            <h4>Google Map</h4>
            <div class="line">
              <el-input v-model="modelData.google_map" class="input-seach" type="textarea"></el-input>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-row>
    <div style="padding-top: 20px">
      <el-button
        :disable="!canSubmit"
        :loading="!canSubmit"
        type="warning"
        size="small"
        @click="updateModelHomeMenu()">Cập nhật
      </el-button>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="'Lịch sử thay đổi'"
      :visible.sync="logModel.dialogVisibleLog"
      width="45%">
      <div class="log-class-user" v-if="logModel.logs">
        <div
          class="item"
          :key="index_1"
          v-for="(item, index_1) in logModel.logs">
          <strong>{{ item.user_request_name }} - {{ item.user_request_email }}</strong> đã cập nhật cấu hình
          <div>
            <span class="time">{{ item.time }}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logModel.dialogVisibleLog = false" size="small">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import {head} from 'lodash'
import {mapActions, mapGetters} from 'vuex'
import tinymce from 'vue-tinymce-editor'
import ls from 'local-storage'

export default {
  name: 'ConfigHeaderFooter',
  components: {
    tinymce
  },
  metaInfo () {
    return {
      title: 'Config Header Footer'
    }
  },
  data () {
    return {
      canSubmit: true,
      logModel: {
        dialogVisibleLog: false,
        activeName: 'first',
        logs: {}
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      modelData: {},
      modelData_ID: 0,
      image: '',
      image_favicon: '',
      image_path: '',
      image_path_favicon: '',
      upload: {
        uploadProcess: false,
        uploadProcessFavicon: false,
        url: process.env.API_URI + 'configs/upload',
        url_not_resize: process.env.API_URI + 'configs/upload-not-resize',
        url_fit_fix: process.env.API_URI + 'configs/upload-fit-fix/1440/400/720/200',
        url_fit_fix2: process.env.API_URI + 'configs/upload-not-resize-2/500/300/200',
        url_fit_fix3: process.env.API_URI + 'configs/upload-not-resize-3',
        headers: {
          Authorization: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModelHomeMenu()
    this.configUpload()
  },
  methods: {
    testSendMail () {
      this.canSubmit = false
      let data = {
        'email': this.modelData.email_noti
      }
      axios.post('configs/check-email-noti-true', data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Vui lòng check email vừa nhập để kiểm tra',
              type: 'success'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    handleImageAdded: async function (file, success, failure) {
      // images_upload_handler: handleImageAdded // Vứt vào đoạn option cạnh chữ 500px
      let formData = new FormData()
      formData.append('file', file.blob())
      let response = await axios.post('configs/upload-not-resize', formData)
      if (response.code === 1) {
        success(response.data.path)
      } else {
        return false
      }
    },
    getImage (data) {
      return process.env.IMAGE_S3_URL + 'storage/images/configs/' + data
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        {name: 'home-index', text: 'Trang chủ'},
        {name: 'configs-home', text: 'Config Home'}
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'home-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModelHomeMenu () {
      this.canSubmit = false
      axios.get('configs/header-footer').then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.modelData = response.data.value
            this.modelData_ID = response.data.id
            this.logModel.logs = response.data.logs
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    updateModelHomeMenu (formName) {
      this.canSubmit = false
      let data = {
        'value': this.modelData
      }
      axios.put('configs/' + this.modelData_ID, data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    addImage1 () {
      this.modelData.footer_list_address.push({
        'key': Math.floor(Math.random() * 100000) + 1,
        'text': '',
        'image': '',
        'note': '',
        'link': '',
        'priority': 0
      })
    },
    removeImage1 (item) {
      var index = this.modelData.footer_list_address.indexOf(item)
      if (index !== -1) {
        this.modelData.footer_list_address.splice(index, 1)
      }
    },

    addImage2 () {
      this.modelData.footer_list_care.push({
        'key': Math.floor(Math.random() * 100000) + 1,
        'text': '',
        'number': '',
        'priority': 0
      })
    },
    removeImage2 (item) {
      var index = this.modelData.footer_list_care.indexOf(item)
      if (index !== -1) {
        this.modelData.footer_list_care.splice(index, 1)
      }
    },

    addImage3 () {
      this.modelData.footer_list_policy.push({
        'key': Math.floor(Math.random() * 100000) + 1,
        'text': '',
        'link': '',
        'priority': 0
      })
    },
    removeImage3 (item) {
      var index = this.modelData.footer_list_policy.indexOf(item)
      if (index !== -1) {
        this.modelData.footer_list_policy.splice(index, 1)
      }
    },

    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh trường có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.image = response.data.name
        this.image_path = response.data.path_sm
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    },
    handleFaviconSuccess (response) {
      this.upload.uploadProcessFavicon = false
      if (response.code) {
        this.image_favicon = response.data.name
        this.image_path_favicon = process.env.IMAGE_URL + response.data.path
        this.modelData.favicon = process.env.IMAGE_URL + response.data.path
      }
    },
    beforeFaviconUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh trường có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleFaviconProcess (event, file, fileList) {
      this.upload.uploadProcessFavicon = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}

.huhu {
  margin-top: 10px;
}

.line {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
}

.line input {
  margin-right: 10px;
}

.image-preview {
  height: 50px;
  width: 50px;
  margin-right: 10px;
}
</style>
<style type="text/css">
.updatSeting .course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}

.course-uploader .el-upload:hover {
  border-color: #409EFF;
}

.updatSeting .course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 180px;
  height: 100px;
  line-height: 100px !important;
  text-align: center;
}

.updatSeting .courseSettig {
  width: 100px;
  height: 100px;
}

.courseSetting {
  display: block;
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/config-home/Update5.vue